import { render, staticRenderFns } from "./RedmineIssuesListPage.vue?vue&type=template&id=6f9080fb&scoped=true"
import script from "./RedmineIssuesListPage.vue?vue&type=script&lang=js"
export * from "./RedmineIssuesListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9080fb",
  null
  
)

export default component.exports